import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PostDetail } from 'types/PostDetail';
import { getPostAttachmentCount } from 'app/modules/posts/utils/getPostAttachmentCount';

type Props = {
  post: PostDetail;
};

const MediaCountLabel: React.FC<Props> = ({ post }) => {
  const { t } = useTranslation();

  const label = useMemo(() => {
    const { images, videos, documents } = getPostAttachmentCount(
      post?.attachments?.cards || [],
    );

    const tImage = t('imageWithCount', { count: images });
    const tVideo = t('videoWithCount', { count: videos });
    const tDocument = t('documentWithCount', {
      count: documents,
      defaultValue: '{{count}} document',
    });

    const parts = [
      ...(images > 0 ? [tImage] : []),
      ...(videos > 0 ? [tVideo] : []),
      ...(documents > 0 ? [tDocument] : []),
    ];

    return parts.length > 0 ? parts.join(' and ') : t('noMediaFound');
  }, [t, post.attachments.cards]);

  return (
    <div className="tw-w-full tw-px-2 tw-text-left tw-text-xs tw-text-grayscale-100">
      {label}
    </div>
  );
};

export default MediaCountLabel;
